import { reactive } from 'vue';
import { useApi } from './api';
import type { Workspace } from './api/resources';
import { parse, format, isValid } from 'date-fns';

const state = reactive({
	loading: true,
	canChooseResort: true,
	resorts: [] as Workspace[],
	home: {} as { title: string; description: string },
	globalFilters: {} as { [key: string]: string },
	arrivalDate: undefined as string | undefined,
});

export default function useStore() {
	const api = useApi();

	return {
		state,

		getResort(ref: string): Workspace | undefined {
			return state.resorts.find((workspace: Workspace) => workspace.ref === ref);
		},

		hasResort(ref: string): boolean {
			return state.resorts.some((workspace: Workspace) => workspace.ref === ref);
		},

		async getResorts() {
			if (state.resorts.length > 0) {
				Promise.resolve();
				return;
			}

			const response = await api.workspaces.get();

			state.home = {
				title: response.data.title,
				description: response.data.description,
			};

			state.resorts = response.data.data;

			state.loading = false;
		},

		setGlobalFilters(filters: { [key: string]: string }) {
			state.globalFilters = filters;
		},

		setInitialArrivalDate(date: string | null | undefined) {
			if (!date) {
				state.arrivalDate = undefined;
				return;
			}

			const variants = ['yyyy-MM-dd', 'dd-MM-yyyy'];

			for (const variant of variants) {
				const parsedDate = parse(date, variant, new Date());
				if (isValid(parsedDate)) {
					state.arrivalDate = format(parsedDate, 'yyyy-MM-dd'); // store as server format
					break;
				}
			}
		},
	};
}
